export const RULE_SET_ID = "baseline-2026-01";
export const ORG_ID = "automatry";
export const RULE_SET_VERSION = "2026.01";
export const CREATED_AT = "2026-06-21T00:00:00.000Z";
export const SOURCE_REFS = {
    baselineRules: {
        sourceId: "baseline-rules-2026-06-20",
        sourceKind: "note",
        authorityClass: "baseline_note",
        locator: "_research/09-baseline-rules.md:33-89",
        quote: "Knowledge Base rows captured from Baseline workbook notes; Proposal Forge generated code is conflict evidence only."
    },
    methodologyDecisions: {
        sourceId: "spec-methodology-decisions-2026-06-20",
        sourceKind: "rich_decision",
        authorityClass: "rich_live_clarification",
        locator: "_research/SPEC-METHODOLOGY-DECISIONS.md:11-87",
        quote: "Authoritative baseline: Baseline notes supersede Proposal Forge generated rules."
    },
    rulesEncodingPlan: {
        sourceId: "rules-encoding-plan-04",
        sourceKind: "manual_entry",
        authorityClass: "baseline_note",
        locator: "_research/plans/04-rules-encoding.md:1-224",
        quote: "Seed baseline-2026-01 with original NL, enhanced text, tags, deterministic helpers, and open decisions."
    },
    deliveredLoadRelayIoComPolicy: {
        sourceId: "central-load-relay-iocom-delivered-policy",
        sourceKind: "benchmark",
        authorityClass: "benchmark",
        locator: "delivered-source:central-load-relay-iocom-policy:112-178",
        quote: "Delivered panel makeup includes IO/COM-8R x4 plus IO/COM-4R x1 for central load relays; derived-from-delivered pending Rich confirmation."
    },
    edgeLeakDetectionRetrofit: {
        sourceId: "edge-leak-detection-retrofit-benchmark",
        sourceKind: "benchmark",
        authorityClass: "benchmark",
        locator: "delivered-source:edge-leak-detection-retrofit:190-220",
        quote: "Edge/leak retrofit: one self-contained Edge gateway PC per apartment for dashboard and alert workflows; no discrete leak sensors listed."
    },
    ufhSensorQuantityDispute: {
        sourceId: "ufh-sensor-quantity-dispute-benchmark",
        sourceKind: "benchmark",
        authorityClass: "benchmark",
        locator: "delivered-source:ufh-sensor-quantity-dispute:284-287",
        quote: "UFH sensor quantity is genuinely ambiguous: Titan Quote Costs says 447 (Automatry) / 149 (Kane), Panel & Controls says 304. Which is the validation target?"
    },
    supplyAirOffCoilDefaultDecision: {
        sourceId: "supply-air-off-coil-default-rich-2026-06-23",
        sourceKind: "rich_decision",
        authorityClass: "rich_live_clarification",
        locator: "Builder brief 2026-06-23: supply-air off-coil sensor default",
        quote: "Supply-air/off-coil TPTVAV/S is specified by default, one per modelled FCU zone; suppress only when explicitly not required."
    },
    defaultDispositionsBrief: {
        sourceId: "open-rule-default-dispositions-rich-2026-06-27",
        sourceKind: "manual_entry",
        authorityClass: "rich_live_clarification",
        locator: "W2-T5 builder brief 2026-06-27: default dispositions for open rule questions",
        quote: "Open product-policy questions get a defaultDisposition now, but every default remains paired with a visible needsUserDecision until Rich confirms or overrides it."
    }
};
export const ruleCards = [
    {
        id: "rule-source-authority-rich-wins",
        ruleSetId: RULE_SET_ID,
        title: "Baseline source authority",
        originalText: "Where Proposal Forge's agent-generated rules conflict with Rich's notes, Rich wins.",
        enhancedText: "Treat Baseline notes, workbook rows, and captured decisions as authoritative. Proposal Forge generated rules are only regression/conflict evidence.",
        tags: ["source-authority", "proposal-forge-conflict", "traceability"],
        appliesTo: ["all-rules"],
        status: "active",
        sourceRefs: [SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "rule-load-wufh-composite-zone",
        ruleSetId: RULE_SET_ID,
        title: "WUFH composite zone IO",
        originalText: "We assume that UFH actuators are enable only (no 0-10v control). For any UFH zone, we'd assume 2x sensors (1x used and 1x as a redundancy. The redundancy is not terminated, so does NOT take up IO on a controller).",
        enhancedText: "A wet UFH control zone consumes UI 2, AO 0, DO 1: one dedicated room/control temperature input, one active wet UFH floor/limit input, and one enable output. Spare sensors are BOM-only and not terminated.",
        tags: ["load-profile", "wufh", "io", "sensors"],
        appliesTo: ["wufh", "control-zone", "point-demand"],
        status: "active",
        sourceRefs: [SOURCE_REFS.baselineRules, SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "rule-load-eufh-load-only",
        ruleSetId: RULE_SET_ID,
        title: "EUFH load IO and control sensor split",
        originalText: "A load relay is required on the output of a controller for any EUFH zone. Every control zone gets a dedicated temperature input; do NOT use the UFH limit sensor as control temp.",
        enhancedText: "An EUFH load profile is UI 0, AO 0, DO 1. The EUFH limit/cutoff sensor is not controller UI. A separate control-zone temperature input is still required and is added by the sensor/control-zone rule.",
        tags: ["load-profile", "eufh", "io", "control-sensor"],
        appliesTo: ["eufh", "control-zone", "point-demand"],
        status: "active",
        sourceRefs: [SOURCE_REFS.baselineRules, SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "rule-sensor-spares-not-terminated",
        ruleSetId: RULE_SET_ID,
        title: "Spare sensors do not consume IO",
        originalText: "Spare / doubled UFH sensors are not terminated, so do NOT take up IO on a controller.",
        enhancedText: "Only active terminated sensors consume controller UI. Spare, doubled, and redundancy sensors remain supply/BOM items until explicitly marked active and terminated.",
        tags: ["sensor", "spare", "redundancy", "io"],
        appliesTo: ["sensors", "point-demand", "bom"],
        status: "active",
        sourceRefs: [SOURCE_REFS.baselineRules, SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "rule-supply-air-off-coil-sensor-default",
        ruleSetId: RULE_SET_ID,
        title: "Supply-air off-coil sensor default",
        originalText: "Fit TPTVAV/S supply-air/off-coil sensors as standard, one per FCU.",
        enhancedText: "Derive one TPTVAV/S supply-air/off-coil temperature sensor per modelled FCU zone by default. This is a higher-quality install and improves Edge anomaly detection. Do not derive return-air sensors from this rule, and allow explicit scoped overrides to suppress the supply-air sensors where the spec removes them.",
        tags: ["sensor", "supply-air", "off-coil", "fcu", "edge"],
        appliesTo: ["sensors", "fcu", "bom"],
        status: "active",
        sourceRefs: [
            SOURCE_REFS.supplyAirOffCoilDefaultDecision,
            SOURCE_REFS.methodologyDecisions
        ],
        createdAt: CREATED_AT
    },
    {
        id: "rule-load-towel-rail-central-relay",
        ruleSetId: RULE_SET_ID,
        title: "Towel rails are central relay loads",
        originalText: "Towel rails are typically wired back to a central panel/location, and would require a load relay per bathroom.",
        enhancedText: "Towel rails are not controller zones and never consume a 710R or MZ zone slot. Count them from the takeoff hard count and derive central load-relay outputs.",
        tags: ["towel-rail", "load-relay", "not-zone", "central-io"],
        appliesTo: ["towel_rail", "controller-selection", "infrastructure"],
        status: "active",
        sourceRefs: [SOURCE_REFS.baselineRules, SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "rule-controller-710r-two-zone",
        ruleSetId: RULE_SET_ID,
        title: "TP-C-710R-IP two-zone capacity",
        originalText: "TP-C-710R-IP is a 2-zone controller. Zone 1 is the primary FCU zone; Zone 2 is a secondary standalone UFH/EUFH/heat-only zone.",
        enhancedText: "A 710R may hold at most one primary slot and one secondary slot. Same-room WUFH may be combined into the primary FCU strategy without consuming the secondary slot.",
        tags: ["controller", "710r", "zone-capacity", "packing"],
        appliesTo: ["controller-selection", "zone-packing"],
        status: "active",
        sourceRefs: [SOURCE_REFS.baselineRules, SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "rule-controller-pack-710-secondary-before-mz",
        ruleSetId: RULE_SET_ID,
        title: "Pack 710R secondaries before MZ",
        originalText: "Pack ALL 710R secondary zone slots BEFORE allocating any MZ-503 controllers.",
        enhancedText: "Use available 710R secondary slots for standalone WUFH/EUFH/heat-only zones before selecting an MZ controller. MZ is overflow only.",
        tags: ["controller", "710r", "mz", "packing", "overflow"],
        appliesTo: ["controller-selection", "zone-packing"],
        status: "active",
        sourceRefs: [SOURCE_REFS.baselineRules, SOURCE_REFS.rulesEncodingPlan],
        createdAt: CREATED_AT
    },
    {
        id: "rule-controller-single-heat-only-710",
        ruleSetId: RULE_SET_ID,
        title: "Single standalone heat-only prefers 710R",
        originalText: "When there is 1 standalone Heat Only zone, use an additional FCU 710 instead of an MZ-503.",
        enhancedText: "If a single standalone heat-only zone cannot fit into an existing 710R secondary slot, add another 710R using its primary slot rather than defaulting to MZ.",
        tags: ["controller", "710r", "heat-only", "mz", "overflow"],
        appliesTo: ["controller-selection", "zone-packing"],
        status: "active",
        sourceRefs: [SOURCE_REFS.baselineRules, SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "rule-infrastructure-netmaster-zero-io",
        ruleSetId: RULE_SET_ID,
        title: "Netmaster has zero IO",
        originalText: "A netmaster has NO IO, and no control strategy logic in it.",
        enhancedText: "Netmaster can provide scheduling, mapping, alarms, and integration capabilities, but physical inputs/outputs must terminate on controllers or IO modules.",
        tags: ["netmaster", "io", "control-strategy", "infrastructure"],
        appliesTo: ["netmaster", "io-accounting", "infrastructure"],
        status: "active",
        sourceRefs: [SOURCE_REFS.baselineRules, SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "rule-infrastructure-central-panel-conditional",
        ruleSetId: RULE_SET_ID,
        title: "Central panels are conditional",
        originalText: "We can't always assume a central control panel, but there is a high chance of one.",
        enhancedText: "Derive panels/enclosures only when central equipment or mapped IO requires them. Do not add one unconditionally per apartment type.",
        tags: ["central-panel", "enclosure", "infrastructure", "conditional"],
        appliesTo: ["infrastructure", "panel", "enclosure"],
        status: "active",
        sourceRefs: [SOURCE_REFS.baselineRules, SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "rule-infrastructure-metering-cascade",
        ruleSetId: RULE_SET_ID,
        title: "Metering derives protocol hardware",
        originalText: "Metering requirements often cascade into extra hardware: protocol gateways, energy-metering units, and meter-interface modules.",
        enhancedText: "When approved requirements or structured takeoff counts indicate metering in Titan scope, derive the protocol and topology from evidence. Verified M-Bus or wireless M-Bus metering uses the central cascade: gateway where required, EMS/energy manager, and IO-COM-EM8 only for hardwired pulse/analogue-style endpoints. Verified Modbus RTU meters that terminate directly on the TP-NM-R-EM-D NetMaster use the NetMaster as bus master: suppress standalone gateway, TP-EM-16, and IO-COM-EM8; emit the RS485 topology note and BACnet/IP BMS exposure when required. Verified pulse metering lands on IO-COM-EM8 pulse inputs read by the NetMaster, without an MB-10 gateway or TP-EM-16 EMS. If evidence is pulse-only and/or by others with no Titan gateway/interface/EMS scope, record the exclusion and do not derive metering gateway, interface, EMS, or metering-enclosure hardware. If metering is required but protocol/topology is not verified, default to Modbus-on-NetMaster, do not emit the M-Bus cascade, and raise a non-blocking needsUserDecision assumption that Modbus cards are required in the meters.",
        tags: [
            "metering",
            "m-bus",
            "modbus",
            "pulse",
            "topology",
            "gateway",
            "infrastructure"
        ],
        appliesTo: ["metering", "gateway", "io_module", "infrastructure", "catalog"],
        status: "active",
        sourceRefs: [SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "rule-infrastructure-panel-tier-selection",
        ruleSetId: RULE_SET_ID,
        title: "Panel enclosure tier by contents",
        originalText: "Panel/enclosure SKU depends on what the central controls panel must house.",
        enhancedText: "Select the panel/enclosure tier from central contents: Netmaster/PSU only can use the base residential Netmaster enclosure; metering, gateways, EMS, MZ, or IO-heavy contents require the larger energy-monitoring/tiered enclosure route. If no central kit is present, omit the panel. If the required tier has no reviewed catalog SKU, emit a needsUserDecision risk.",
        tags: ["panel", "enclosure", "tier", "netmaster", "metering", "infrastructure"],
        appliesTo: ["panel", "enclosure", "infrastructure", "catalog"],
        status: "active",
        sourceRefs: [SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "rule-infrastructure-load-relay-io-com-modules",
        ruleSetId: RULE_SET_ID,
        title: "Central load relays use IO/COM relay modules",
        originalText: "Delivered central load-relay panel makeup used IO/COM-8R x4 plus IO/COM-4R x1 for central load relays.",
        enhancedText: "For central load-relay outputs, select real IO/COM relay modules: pack full groups into IO/COM-8R, use IO/COM-4R for a one-to-four output remainder, and use another IO/COM-8R when the remainder is five to seven. This follows delivered IO/COM relay-module evidence; Rich can confirm final policy.",
        tags: [
            "load-relay",
            "io-module",
            "io-com-8r",
            "io-com-4r",
            "derived-from-delivered"
        ],
        appliesTo: ["load-relay", "infrastructure", "product-selection"],
        status: "active",
        sourceRefs: [
            SOURCE_REFS.deliveredLoadRelayIoComPolicy,
            SOURCE_REFS.methodologyDecisions
        ],
        createdAt: CREATED_AT
    },
    {
        id: "rule-edge-leak-detection-kit",
        ruleSetId: RULE_SET_ID,
        title: "Edge leak detection derives one Edge gateway",
        originalText: "Delivered Edge leak detection used an Edge gateway per apartment, not a change to the base Titan controller selection.",
        enhancedText: "When an approved Edge leak-detection feature is present, derive one self-contained Edge gateway PC per apartment provision unit. Record BACnet-to-cloud connectivity and keep cabling as an installation note, not a counted cable SKU.",
        tags: ["edge", "leak-detection", "bacnet", "cloud", "infrastructure"],
        appliesTo: ["edge_compute", "edge_gateway"],
        status: "active",
        sourceRefs: [SOURCE_REFS.edgeLeakDetectionRetrofit],
        createdAt: CREATED_AT
    },
    {
        id: "rule-edge-leak-input-reuse-default",
        ruleSetId: RULE_SET_ID,
        title: "Leak detection defaults to existing Titan inputs",
        originalText: "Delivered Edge leak-detection BOM evidence lists no discrete leak sensors; the open question is whether the delivered feature reused existing Titan inputs.",
        enhancedText: "Model leak detection as reusing the existing Titan/BACnet input estate by default. Do not invent dedicated leak sensors. Emit a needsUserDecision risk so the estimator confirms whether the project requires dedicated leak-rope or leak-sensor hardware.",
        tags: ["edge", "leak-detection", "sensors", "needsUserDecision"],
        appliesTo: ["edge-feature", "risk", "infrastructure"],
        status: "active",
        sourceRefs: [SOURCE_REFS.edgeLeakDetectionRetrofit],
        createdAt: CREATED_AT
    },
    {
        id: "rule-screen-rdu-direct-wired",
        ruleSetId: RULE_SET_ID,
        title: "RDU direct-wired topology",
        originalText: 'RDU is an older variant screen, and is wired differently than the 4" and 7". It is a zonal display, and it is wired directly to the FCU controllers.',
        enhancedText: "RDU is a one-to-one, hard-wired local display for its FCU controller. It is not a PoE/network screen and does not consume a network switch port.",
        tags: ["rdu", "screen", "direct-wired", "networking"],
        appliesTo: ["screen-rules", "ui", "mapping"],
        status: "active",
        sourceRefs: [SOURCE_REFS.baselineRules, SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "rule-screen-networked-ts4-ts7",
        ruleSetId: RULE_SET_ID,
        title: "TS-4 and TS-7 are network screens",
        originalText: '4" and 7" screen: These are PoE devices, so it requires a network switch.',
        enhancedText: "TS-4 and TS-7 displays are PoE/network devices. Size switch ports from networked screens, Netmaster, BMS connection, and uplinks; exclude RDU from switch-port demand.",
        tags: ["ts4", "ts7", "screen", "poe", "network-switch"],
        appliesTo: ["screen-rules", "infrastructure", "networking"],
        status: "active",
        sourceRefs: [SOURCE_REFS.baselineRules, SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "rule-question-load-relay-product-mapping",
        ruleSetId: RULE_SET_ID,
        title: "Load relay mapping superseded by delivered IO/COM policy",
        originalText: "Load-relay product alignment (TP-LRM-4 vs 2026 GOLD catalog) is open.",
        enhancedText: "Superseded by the delivered IO/COM-8R and IO/COM-4R relay-module policy. Keep this card as historical context only.",
        tags: ["answered-question", "load-relay", "product-mapping"],
        appliesTo: ["load-relay", "infrastructure", "catalog"],
        status: "superseded",
        sourceRefs: [
            SOURCE_REFS.methodologyDecisions,
            SOURCE_REFS.deliveredLoadRelayIoComPolicy
        ],
        createdAt: CREATED_AT
    },
    {
        id: "rule-question-return-air-default",
        ruleSetId: RULE_SET_ID,
        title: "Return air sensor default unresolved",
        originalText: "Return-air sensor default is an open question for the user.",
        enhancedText: "Supply-air/off-coil TPTVAV/S is now defaulted per FCU by rule-supply-air-off-coil-sensor-default. Return/extract air sensor should not be silently defaulted until the user confirms the rule.",
        tags: ["open-question", "sensor", "return-air"],
        appliesTo: ["sensors", "fcu", "load-profile"],
        status: "needs_clarification",
        sourceRefs: [
            SOURCE_REFS.methodologyDecisions,
            SOURCE_REFS.supplyAirOffCoilDefaultDecision
        ],
        createdAt: CREATED_AT
    }
];
export const sourcePrecedenceDefaultQuestion = {
    id: "open-question-source-precedence-default",
    ruleSetId: RULE_SET_ID,
    title: "Source precedence and override authority",
    question: "Should source precedence follow live-note > authored-note > client-spec > drawings > take-off > DESOPS > client-email > estimator-override > RFI > benchmark, and should notes that would override the spec become compliance notes plus needsUserDecision instead of silent auto-overrides?",
    defaultDisposition: {
        disposition: "live-note>authored-note>client-spec>drawings>take-off>desops>client-email>estimator-override>rfi>benchmark; spec-overriding-note-becomes-compliance-note-plus-needsUserDecision",
        rationale: "Use the authored precedence order now so the build can proceed, but surface any spec override as an explicit user decision rather than hardening it as product policy.",
        sourceRefs: [SOURCE_REFS.defaultDispositionsBrief]
    },
    status: "open",
    riskCategory: "needsUserDecision",
    relatedRuleCardIds: ["rule-source-authority-rich-wins"],
    sourceRefs: [SOURCE_REFS.methodologyDecisions, SOURCE_REFS.defaultDispositionsBrief],
    createdAt: CREATED_AT
};
export const openQuestions = [
    {
        id: "open-question-netmaster-default-trigger",
        ruleSetId: RULE_SET_ID,
        title: "Netmaster hard-default versus trigger",
        question: "Should every residential apartment default to one Netmaster, or should Netmaster only be added when app, metering, BMS, alarms, central mapping, scheduling, or another explicit trigger is present?",
        defaultDisposition: {
            disposition: "netmaster-hard-when-app-metering-bms-alarms-central-screen-scheduling-or-mapping-present; bare-fcu-only-omits-netmaster-with-needsUserDecision",
            rationale: "Add Netmaster only for explicit supervisory/integration triggers now; bare FCU-only scope remains an open product-policy decision every time.",
            sourceRefs: [SOURCE_REFS.defaultDispositionsBrief]
        },
        status: "open",
        riskCategory: "needsUserDecision",
        relatedRuleCardIds: ["rule-infrastructure-netmaster-zero-io"],
        sourceRefs: [SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "open-question-panel-omission-rule",
        ruleSetId: RULE_SET_ID,
        title: "Central panel omission rule",
        question: "What exact conditions allow omission of a central panel/enclosure for a simple FCU-only apartment, and should the rule vary by tender level?",
        defaultDisposition: {
            disposition: "central-panel-only-when-central-kit-or-mapped-io-triggers; omission-case-emits-needsUserDecision",
            rationale: "Keep panels conditional so the engine does not add one unconditionally, but record the omission case for Rich to confirm.",
            sourceRefs: [SOURCE_REFS.defaultDispositionsBrief]
        },
        status: "open",
        riskCategory: "needsUserDecision",
        relatedRuleCardIds: ["rule-infrastructure-central-panel-conditional"],
        sourceRefs: [SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "open-question-mbus-gateway-product",
        ruleSetId: RULE_SET_ID,
        title: "M-Bus gateway product mapping",
        question: "Which reviewed 2026 catalog product should represent the MB-10 / M-Bus converter used for HIU and heat-metering projects?",
        status: "open",
        riskCategory: "needsUserDecision",
        relatedRuleCardIds: ["rule-infrastructure-metering-cascade"],
        sourceRefs: [SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "open-question-panel-tier-sku-selection",
        ruleSetId: RULE_SET_ID,
        title: "Expanded panel tier SKU mapping",
        question: "Which reviewed panel/enclosure SKU should represent expanded panels that house MZ controllers, IO modules, gateways, EMS, and load relays beyond the Netmaster enclosure family?",
        status: "open",
        riskCategory: "needsUserDecision",
        relatedRuleCardIds: ["rule-infrastructure-panel-tier-selection"],
        sourceRefs: [SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "open-question-load-relay-product-mapping",
        ruleSetId: RULE_SET_ID,
        title: "Load-relay product mapping",
        question: "Answered from delivered IO/COM-8R plus IO/COM-4R central relay-module evidence; Rich can confirm final policy.",
        status: "answered",
        riskCategory: "needsUserDecision",
        relatedRuleCardIds: [
            "rule-question-load-relay-product-mapping",
            "rule-infrastructure-load-relay-io-com-modules"
        ],
        sourceRefs: [
            SOURCE_REFS.methodologyDecisions,
            SOURCE_REFS.deliveredLoadRelayIoComPolicy
        ],
        createdAt: CREATED_AT
    },
    {
        id: "open-question-mz-vs-710-multi-overflow",
        ruleSetId: RULE_SET_ID,
        title: "MZ versus 710R multi-overflow threshold",
        question: "For multiple overflow UFH/heat-only zones after all 710R secondary slots are packed, what threshold should prefer MZ over extra 710R controllers?",
        defaultDisposition: {
            disposition: "prefer-extra-710-for-one-overflow-zone; use-mz-for-two-or-more-overflow-zones-after-710-secondaries; emit-needsUserDecision-at-boundary",
            rationale: "A lone overflow should not silently become an MZ policy; two or more overflow zones can use MZ while Rich confirms the boundary.",
            sourceRefs: [SOURCE_REFS.defaultDispositionsBrief]
        },
        status: "open",
        riskCategory: "needsUserDecision",
        relatedRuleCardIds: [
            "rule-controller-pack-710-secondary-before-mz",
            "rule-controller-single-heat-only-710"
        ],
        sourceRefs: [SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "open-question-bms-default",
        ruleSetId: RULE_SET_ID,
        title: "BMS default scope",
        question: "Should BMS connectivity be a default clarification on every residential job, or only a hard equipment trigger when the spec/scope explicitly requires BMS?",
        defaultDisposition: {
            disposition: "bms-only-when-specified; otherwise-do-not-assume-bms-and-emit-needsUserDecision",
            rationale: "Avoid silently adding BMS scope to residential jobs; make the absence of explicit BMS a visible internal decision.",
            sourceRefs: [SOURCE_REFS.defaultDispositionsBrief]
        },
        status: "open",
        riskCategory: "needsUserDecision",
        relatedRuleCardIds: ["rule-infrastructure-netmaster-zero-io"],
        sourceRefs: [SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "open-question-return-air-sensor-default",
        ruleSetId: RULE_SET_ID,
        title: "Return-air sensor default",
        question: "Should return/extract air sensors be defaulted per FCU, offered as a de-risking option, or only specified when explicitly required?",
        defaultDisposition: {
            disposition: "default-to-supply-air-off-coil-sensor; do-not-add-return-air-sensor-unless-specified; emit-needsUserDecision-when-return-vs-supply-is-ambiguous",
            rationale: "Use the confirmed supply-air/off-coil default and keep return-air sensing out unless a requirement or Rich decision adds it.",
            sourceRefs: [
                SOURCE_REFS.defaultDispositionsBrief,
                SOURCE_REFS.supplyAirOffCoilDefaultDecision
            ]
        },
        status: "open",
        riskCategory: "needsUserDecision",
        relatedRuleCardIds: ["rule-question-return-air-default"],
        sourceRefs: [SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "open-question-rdu-ccs-tier-selection",
        ruleSetId: RULE_SET_ID,
        title: "RDU/CCS tender-tier selection",
        question: "When a delivered/tender source names RDU-Touch or TP-CCS-7-W, should the engine preserve that older direct-wired tier or keep the current TS-4/TS-7 network-screen default until Rich confirms the project tier?",
        defaultDisposition: {
            disposition: "local-screen-default-ts4; ts7-central-screen-is-additive-unless-tender-explicitly-replaces-local-stat; do-not-auto-pick-replacement-room",
            rationale: "Keep local room UI visible by default. A central screen only substitutes for a local stat when tender evidence explicitly says so.",
            sourceRefs: [SOURCE_REFS.defaultDispositionsBrief]
        },
        status: "open",
        riskCategory: "needsUserDecision",
        relatedRuleCardIds: [
            "rule-screen-rdu-direct-wired",
            "rule-screen-networked-ts4-ts7"
        ],
        sourceRefs: [SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "open-question-supply-air-sensor-default",
        ruleSetId: RULE_SET_ID,
        title: "FCU supply-air sensor default",
        question: "Answered 2026-06-23: default TPTVAV/S supply-air/off-coil sensors one per modelled FCU zone; allow explicit scoped suppression if not required.",
        defaultDisposition: {
            disposition: "one-tptvav-s-supply-air-off-coil-sensor-per-modelled-fcu-zone; suppress-only-when-explicitly-not-required",
            rationale: "Supply-air/off-coil is the adopted default, but ambiguous return-air-versus-supply-air intent still routes through the open return-air sensor decision.",
            sourceRefs: [
                SOURCE_REFS.defaultDispositionsBrief,
                SOURCE_REFS.supplyAirOffCoilDefaultDecision
            ]
        },
        status: "answered",
        riskCategory: "needsUserDecision",
        relatedRuleCardIds: [
            "rule-supply-air-off-coil-sensor-default",
            "rule-question-return-air-default"
        ],
        sourceRefs: [
            SOURCE_REFS.methodologyDecisions,
            SOURCE_REFS.supplyAirOffCoilDefaultDecision
        ],
        createdAt: CREATED_AT
    },
    {
        id: "open-question-srm-vs-io-com-relay-family",
        ruleSetId: RULE_SET_ID,
        title: "SRM versus IO/COM relay family",
        question: "When delivered sources show SRM/SP/24VAC but current rules select IO/COM relay modules, which relay family should be the default by tender tier and project stage?",
        status: "open",
        riskCategory: "needsUserDecision",
        relatedRuleCardIds: [
            "rule-question-load-relay-product-mapping",
            "rule-infrastructure-load-relay-io-com-modules"
        ],
        sourceRefs: [SOURCE_REFS.methodologyDecisions],
        createdAt: CREATED_AT
    },
    {
        id: "open-question-tptvav-l-ufh-actuator-basis",
        ruleSetId: RULE_SET_ID,
        title: "TPTVAV/L UFH actuator quantity basis",
        question: "TPTVAV/L (UFH actuator/limit sensor) quantity basis is unresolved: the engine emits active plus spare per UFH zone at about x464, while delivered sources show 149, 304, and 447. Should spare/redundancy sensors count in the BOM, and should the basis be per-zone or per-circuit?",
        status: "open",
        riskCategory: "needsUserDecision",
        relatedRuleCardIds: [
            "rule-load-wufh-composite-zone",
            "rule-sensor-spares-not-terminated"
        ],
        sourceRefs: [SOURCE_REFS.baselineRules, SOURCE_REFS.ufhSensorQuantityDispute],
        createdAt: CREATED_AT
    },
    {
        id: "open-question-edge-dedicated-leak-sensors",
        ruleSetId: RULE_SET_ID,
        title: "Dedicated leak sensor scope",
        question: "For Edge leak-detection jobs, should the feature reuse existing Titan/BACnet inputs, or should the quote include dedicated leak-rope or leak-sensor hardware?",
        status: "open",
        riskCategory: "needsUserDecision",
        relatedRuleCardIds: [
            "rule-edge-leak-detection-kit",
            "rule-edge-leak-input-reuse-default"
        ],
        sourceRefs: [SOURCE_REFS.edgeLeakDetectionRetrofit],
        createdAt: CREATED_AT
    }
];
export const DEFAULT_DISPOSITION_QUESTION_IDS = [
    "open-question-source-precedence-default",
    "open-question-netmaster-default-trigger",
    "open-question-panel-omission-rule",
    "open-question-mz-vs-710-multi-overflow",
    "open-question-bms-default",
    "open-question-return-air-sensor-default",
    "open-question-rdu-ccs-tier-selection",
    "open-question-supply-air-sensor-default"
];
export const defaultDispositionQuestions = [
    sourcePrecedenceDefaultQuestion,
    ...openQuestions.filter((question) => DEFAULT_DISPOSITION_QUESTION_IDS.some((questionId) => questionId === question.id))
];
export function getOpenRuleQuestion(questionId) {
    return openQuestions.find((question) => question.id === questionId);
}
export function getDefaultDispositionRuleQuestion(questionId) {
    return defaultDispositionQuestions.find((question) => question.id === questionId);
}
export function makeDefaultDispositionUserDecision(questionId, input = {}) {
    const question = getDefaultDispositionRuleQuestion(questionId);
    if (!question) {
        throw new Error(`Unknown default-disposition rule question: ${questionId}`);
    }
    if (!question.defaultDisposition) {
        throw new Error(`Open rule question ${questionId} has no defaultDisposition to emit.`);
    }
    const sourceRefs = question.defaultDisposition.sourceRefs ?? question.sourceRefs;
    return {
        id: input.id ?? `decision-${question.id}`,
        ...(input.projectId ? { projectId: input.projectId } : {}),
        questionId: question.id,
        questionText: question.question,
        options: [
            {
                id: `option-${question.id}-default`,
                label: "Apply current default",
                disposition: question.defaultDisposition.disposition,
                rationale: question.defaultDisposition.rationale,
                sourceRefs
            }
        ],
        chosenDisposition: question.defaultDisposition.disposition,
        decidedBy: "default",
        status: "open",
        affectedRequirementIds: input.affectedRequirementIds ?? [],
        affectedRuleCardIds: [...question.relatedRuleCardIds],
        affectedRuleTraceRefs: input.affectedRuleTraceRefs ?? [],
        sourceRefs,
        rationale: `${question.defaultDisposition.rationale} This remains a visible needsUserDecision until Rich confirms or overrides it.`
    };
}
export function makeDefaultDispositionUserDecisions(questionIds = DEFAULT_DISPOSITION_QUESTION_IDS, input = {}) {
    return questionIds.map((questionId) => makeDefaultDispositionUserDecision(questionId, input));
}
export function makeRuleTrace(id, ruleCardId, summary, sourceRefs = [SOURCE_REFS.baselineRules]) {
    return {
        id,
        ruleSetId: RULE_SET_ID,
        ruleCardId,
        summary,
        sourceRefs,
        createdAt: CREATED_AT
    };
}
//# sourceMappingURL=sourceAuthority.js.map